<template>
  <div
    class="drift-chat-widget"
    ref="chatWidget"
  >
    <icon
      icon="chat"
    />
  </div>
</template>

<script>
export default {
  mounted () {
    const {chatWidget} = this.$refs
    const openSidebar = (driftApi, event) => {
      event.preventDefault()
      driftApi.sidebar.open()
      return false
    }

    window.drift.on('ready', function (api) {
      const handleClick = openSidebar.bind(this, api)
      chatWidget.addEventListener('click', handleClick)
    })
  },
}
</script>


<style lang="scss">
.drift-chat-widget {
  position: fixed;
  bottom: 16px;
  right: 16px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: $nav-bg;
  color: white;

  .i {
    top: 0;
  }
}
</style>

